import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import {
  breakpoint,
  fontSize,
  size,
} from '@twistopayments/design-system/styles'

export const controls = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${size[12]};
  width: 100%;
  justify-content: flex-end;
  padding: ${size[24]} ${size[24]} 0;

  button {
    background-color: transparent;
    border: none;
    font-size: ${fontSize.lg};
    color: ${theme.palette.primary.mainContrast};
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;

      svg path {
        fill: ${theme.palette.ghost.mediumContrast};
        stroke: ${theme.palette.ghost.mediumContrast};
      }
    }
  }

  svg {
    width: ${size[20]};

    ${breakpoint.up('smMd')} {
      width: ${size[32]};
    }
  }

  ${breakpoint.up('smMd')} {
    width: fit-content;
    padding: 0;
  }
`
